/**
 * UI marker for the Leena-2 product model version.
 *
 * Wherever the UI states a product model version, we append this lime indicator
 * when the version is the Leena-2 product model version
 * (`LEENA2_PRODUCT_MODEL_VERSION`) so it's visually distinguishable from the
 * regular `master` model versions.
 */
import { LEENA2_PRODUCT_MODEL_VERSION } from '@upright/common/model/versions/leena2-version';

/** Lime indicator shown next to the Leena-2 product model version. */
export const LEENA2_VERSION_MARKER = '🍋‍🟩';

export function isLeena2ProductModelVersion(version: string | null | undefined): boolean {
  return version === LEENA2_PRODUCT_MODEL_VERSION;
}

/**
 * Suffix (with a leading space) to append after a displayed product model
 * version string when it is the Leena-2 product model version; `''` otherwise.
 */
export function leena2VersionMarkerSuffix(version: string | null | undefined): string {
  return isLeena2ProductModelVersion(version) ? ` ${LEENA2_VERSION_MARKER}` : '';
}
